const dns_retrieve_domain_records_dialog = {
	description:
		"Geef hier de domeinnaam op waarvan je de bestaande DNS-records wil ophalen. Mogelijkerwijs ontbreken hier enkele records.",

	domain_search_input: {
		label: "Domeinnaam",
		placeholder: "Bijvoorbeeld 'codebee.nl'",
	},
	message: {
		success: "De DNS-records zijn succesvol toegevoegd.",
	},
	search_button: {
		label: "Records ophalen",
	},
	submit_button: {
		label: "Toevoegen ({{record_selected_count}} records)",
	},
	title: "DNS ophalen extern domein",
};

export default dns_retrieve_domain_records_dialog;
